"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SizerPlaceholder = function SizerPlaceholder(props) {
  return _react.default.createElement("div", {
    className: "co-placeholder co-placeholder--animated" // TODO: This should be using <LoadingPlaceholder /> but is not filling 100% height
    ,
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: props.visible ? '100%' : 0
    }
  });
};

SizerPlaceholder.propTypes = {
  visible: _propTypes.bool
};
var _default = SizerPlaceholder;
exports.default = _default;
SizerPlaceholder.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SizerPlaceholder",
  "props": {
    "visible": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};